import { type Reply, type UploadedFile, createReplyData } from 'models';
import { useMutation } from 'query';
import { createComment } from '../../services';
import { useAddComment } from '../hooks';

export const useCreateCommentMutation = () => {
  const addComment = useAddComment();

  return useMutation<
    Reply,
    {
      attachments?: UploadedFile[];
      contentObjectId: string;
      htmlContent?: string;
      parentId: string;
      textContent?: string;
    }
  >({
    async mutationFn({ attachments, htmlContent, parentId, textContent }) {
      const response = await createComment({
        content_object: {
          attachments: attachments?.map((attachment) => ({
            id: attachment.id,
          })),
          html_content: htmlContent,
          parent_id: parentId,
          text_content: textContent,
        },
      });

      return createReplyData(response.data);
    },
    onSuccess(comment, { contentObjectId }) {
      addComment({ contentObjectId, reply: comment });
    },
  });
};
